import { Component, EventEmitter, Input, Output } from '@angular/core';
import { commonComponentImages } from '@images/common-components-images';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
})
export class ConfirmationDialogComponent {
  visible: boolean = false;
  images = commonComponentImages;
  @Input() title: string = 'Confirmation';
  @Input() cancelable: boolean = true;
  @Input() zindex: number = null;
  @Input() primary_btn_name: string = 'Delete';
  @Input() secondary_btn_name: string = 'Cancel';
  @Output() confirmed = new EventEmitter(null);
  @Output() canceled = new EventEmitter(null);
  @Input() viewonly: boolean = false;
  @Input() propertyHistory: boolean = false;

  confirm() {
    this.confirmed.emit('confirm');
    this.hide();
  }

  close() {
    this.canceled.emit('close');
    this.hide();
  }

  cancel() {
    this.canceled.emit('canceled');
    this.hide();
  }

  show() {
    this.visible = true;
  }

  hide() {
    this.visible = false;
  }

  reset() {
    this.visible = false;
    this.title = 'Confirmation';
    this.cancelable = true;
    this.primary_btn_name = 'Delete';
    this.confirmed = this.canceled = new EventEmitter(null);
  }
}
